import { ADD_DATA, CLOSE_MODAL } from '../types'
export default (state, action) => {
    switch (action.type) {
        case ADD_DATA:
            return {
                ...state,
                data: [action.payload]
            }
        case CLOSE_MODAL:
            return {
                ...state,
                data: []
            }
        default:
            return state;
    }
}